export default "__VITE_ASSET__s2g9k36h__"